'use strict';

module.exports = require('./client.browser');
